// main.js

import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './plugins/router';
import Vue3TreeOrg from 'vue3-tree-org';

import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import 'vue3-tree-org/lib/vue3-tree-org.css';

let app;

if (!app) {
  app = createApp(App);

  app.use(vuetify);
  app.use(router);
  app.use(Vue3TreeOrg);

  app.mount('#app');
}
